jQuery(document).ready(function($) {
    $('.carousel-outer').each(function() {
        $(this).append('<a href="#" class="cycle-next"><span class="visually-hidden">Next</span></a><a href="#" class="cycle-prev"><span class="visually-hidden">Previous</span></a><div class="cycle-pager"></div>');
        $(this).cycle({
            'slides' : '.carousel-slide',
            'timeout' : 5000,
            swipe: true,
            'swipe-fx': 'scrollHorz',
            speed: 2000,
            fx : 'scrollHorz'
        });
        var themeBasePath = jQuery('meta[name=theme-base-path]').attr('content')+'/';
        var $that = $(this);
        $.ajax(themeBasePath+'dist/img/arrow-left.svg',{
            dataType: 'text',
            success: function(data) {
                $that.find('.cycle-next').html(data);
                $that.find('.cycle-prev').html(data);
            }
        });
        $(this).on('cycle-before',function(event,opts,outgoingSlide, incomingSlide,forwardFlag) {
            var headingAnimateIn;
            var headingAnimateOut;
            if (forwardFlag)
            {
                headingAnimateOut = $(outgoingSlide).find($('.elementor-heading-title'));
                headingAnimateIn = $(incomingSlide).find($('.elementor-heading-title'));
                headingAnimateOut.css({
                    left: 0,
                }).animate({
                    left: '-50vw'
                },2000);
                headingAnimateIn.css({
                    left: '50vw',
                }).animate({
                    left: 0
                },2000);
            }
            else
            {
                headingAnimateOut = $(outgoingSlide).find($('.elementor-heading-title'));
                headingAnimateIn = $(incomingSlide).find($('.elementor-heading-title'));
                headingAnimateIn.css({
                    left: '-50vw',
                }).animate({
                    left: 0
                },2000);
                headingAnimateOut.css({
                    left: 0,
                }).animate({
                    left: '50vw'
                },2000);
            }
        });
        $(this).on('cycle-after',function(event,opts,outgoingSlide, incomingSlide,forwardFlag) {
            $(this).find('.cycle-slide-prev').removeClass('cycle-slide-prev');
        });
    });
    $('.single-client.image-switcher').each(function() {
        var title = $(this).attr('title');
        $(this).find('.content-image').append('<div class="image-title">'+title+'</div>');
    });
});